import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

const _externalLinkAltSolid: FunctionComponent<{ className?: string }> = ({ className }) => (
    <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill='none'>
        <path
            d='M11.25 3.125V4.375H14.7266L7.05078 12.0508L7.94922 12.9492L15.625 5.27344V8.75H16.875V3.125H11.25ZM3.125 5.625V16.875H14.375V8.75L13.125 10V15.625H4.375V6.875H10L11.25 5.625H3.125Z'
            fill='#0288D1'
        />
    </svg>
);

const ExternalLinkAltSolid = styled(_externalLinkAltSolid)``;

export default ExternalLinkAltSolid;
